import React, { FunctionComponent } from "react";

const ImageFileAddIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/files-folders/image-files/image-file-add
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 14.25V20.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.25 17.25H20.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 20.25H2.25C1.85218 20.25 1.47064 20.092 1.18934 19.8107C0.908035 19.5294 0.75 19.1478 0.75 18.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.879C13.2765 0.750085 13.6578 0.907982 13.939 1.189L16.811 4.061C17.092 4.3422 17.2499 4.72345 17.25 5.121V8.25"
      ></path>
      <path
        stroke="currentColor"
        d="M5.25 6.375C5.04289 6.375 4.875 6.20711 4.875 6C4.875 5.79289 5.04289 5.625 5.25 5.625"
      ></path>
      <path
        stroke="currentColor"
        d="M5.25 6.375C5.45711 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.45711 5.625 5.25 5.625"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.279 9.8999L11.25 8.2499C11.1824 8.14826 11.0911 8.06467 10.9838 8.0064C10.8766 7.94814 10.7567 7.91696 10.6347 7.91558C10.5127 7.9142 10.3921 7.94266 10.2836 7.99849C10.1751 8.05431 10.0818 8.13582 10.012 8.2359L8.012 11.0869L6.78 10.0999C6.69884 10.0348 6.60504 9.98739 6.50456 9.96053C6.40408 9.93368 6.2991 9.92802 6.19632 9.94391C6.09353 9.95981 5.99517 9.9969 5.90749 10.0529C5.8198 10.1088 5.74472 10.1824 5.687 10.2689L3.75 14.2499H8.25"
      ></path>
    </svg>
  );
};

export default ImageFileAddIcon;
